import type { ListItemProps } from "react-native-paper";
import type { LevelIconName } from "../../icon";
import { useAppTheme } from "../../useAppTheme";
import OptionListItem from "../QuickStudyModal/OptionListItem";

export type BgColorType = "none" | "low" | "medium" | "high";

type Props = {
	rightText?: string;
	handleSelectCheckbox: () => void;
	bgColorType?: BgColorType;
	color?: string;
	locked?: boolean;
	status: "checked" | "unchecked";
	textColor?: string;
	disableAll?: boolean;
	testID?: string;
	icon?: LevelIconName;
	variant?: "checkbox" | "radio";
} & ListItemProps;

const FilterListItem = ({
	rightText,
	title,
	handleSelectCheckbox,
	bgColorType,
	color,
	disabled,
	locked,
	status,
	textColor,
	disableAll,
	testID,
	icon,
	variant = "checkbox",
}: Props) => {
	const theme = useAppTheme();
	const checked = status === "checked";
	const countTone = bgColorType === "low" ? "error" : "neutral";
	const titleLabel = typeof title === "string" ? title : "Filter item";
	const bgColorMap: Record<BgColorType, string> = {
		none: theme.palette.progress.noneBackground,
		medium: theme.palette.progress.medium,
		low: theme.palette.progress.low,
		high: theme.palette.progress.high,
	};

	return (
		<OptionListItem
			id={titleLabel}
			label={titleLabel}
			icon={icon}
			countLabel={rightText}
			countTone={countTone}
			countBackgroundColor={
				color ?? (bgColorType ? bgColorMap[bgColorType] : undefined)
			}
			countTextColor={
				textColor ?? (bgColorType ? theme.colors.white : undefined)
			}
			checked={checked}
			disabled={disabled || disableAll}
			locked={locked}
			selectionVariant={variant}
			testID={testID}
			onToggle={handleSelectCheckbox}
		/>
	);
};

export default FilterListItem;
